module.exports = __webpack_public_path__ + "img/record-vinyl.45f9c834.svg";